<template>
  <div>
    <v-flex xs12 sm12 md12>
      <v-data-table :headers="headers" :items="namedConfigurationEntry.ColumnConfigurations" hide-actions class="elevation-1" :loading="isLoadingSubmit" :pagination.sync="pagination">
        <template v-slot:headers="props">
          <tr>
            <th v-for="header in props.headers" :key="`col-header${header.value}`" :class="[header.sortable ? 'column sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" :style="{'text-align': header.align || 'start'}" @click="changeSort(header)">
              <v-icon small v-if="header.sortable">arrow_upward</v-icon>
              {{ header.text || header.value }}
              <v-menu v-model="showValidationModeInfo" offset-x v-if="header.value==dataValidationModeProperty">
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" flat icon>
                    <v-icon>info</v-icon>
                  </v-btn>
                </template>
                <DataValidationModeInfo />
              </v-menu>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <td>
            <div>{{ getAliasDefaultName(props.item) }}</div>
            <div>
              <v-chip v-if="props.item.Implemented != null && (!props.item.Implemented)" :value="true" color="red" dark small>
                Not
                Implemented</v-chip>
            </div>
          </td>
          <td>
            <!-- <v-checkbox :disabled="!props.item.CanConfigureValidationRequirement || !editMode"
              :input-value="props.item.ValidationRequired"
              @change="updateColumnDataValidationMode($event, props.item)"></v-checkbox> -->
            <DataValidationModeDropDown :value="props.item.DataValidationMode" :editMode="editMode" :canConfigureDataValidationMode="props.item.CanConfigureDataValidationMode" :implemented="props.item.Implemented" @change="updateColumnDataValidationMode($event, props.item)" />
          </td>
          <td>
            <template v-if="hasAliases(props.item)">
              <v-chip v-for="item in props.item.NameAliases.filter(x => !x.IsDefault)" :key=item.Name small>
                {{item.Name}}
              </v-chip>
            </template>
          </td>
          <td>
            <v-btn color="blue" outline small class="elevation-1" @click="openEditColumnModal(props.item.Id)">Settings
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-flex>
    <v-layout align-center justify-end class="mt-3 mr-2">
      <template v-if="editMode">
        <v-btn @click="saveConfiguration" color="primary">Save
          <v-icon class="ml-2" dark>save</v-icon>
        </v-btn>
        <v-btn @click="cancelConfiguration" color="error">Cancel
          <v-icon class="ml-2" dark>cancel</v-icon>
        </v-btn>
      </template>
      <template v-else>
        <v-btn @click="setEditMode(true)" color="warning">Edit
          <v-icon class="ml-2" dark>create</v-icon>
        </v-btn>
        <v-btn @click="goToConfigList" color="secondary">Back
        </v-btn>
      </template>
    </v-layout>
    <component :is="currentComponent" v-model="modalValue" :configName="ConfigurationSettingName" :columnId="selectedColumnId" :editMode="editMode" />
  </div>
</template>


<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  import ColumnEditModal from './modals/ColumnEditModal'
  import AnalyteNameColumnModal from './modals/AnalyteNameColumnModal'
  import DataValidationModeInfo from './DataValidationMode/DataValidationModeInfo'
  import DataValidationModeDropDown from './DataValidationMode/DataValidationModeDropDown'

  import columnEditModalMapping from '../config/columnEditModalMapping'

  import genericMixin from '../mixins/genericMixin'
  import routingMixin from '../mixins/routingMixin'

  import {
    DataValidationModeProperty,
  } from '../store/eddConfiguration'

  const app = createNamespacedHelpers('app')
  const eddConfiguration = createNamespacedHelpers('plugin/eddConfiguration')
  export default {
    components: {
      ColumnEditModal,
      AnalyteNameColumnModal,
      DataValidationModeInfo,
      DataValidationModeDropDown,
    },
    mixins: [genericMixin, routingMixin],
    props: {
      ConfigurationSettingName: {
        type: String,
        required: true,
      },
      initialEditMode: {
        type: Boolean,
        required: false,
      },
    },
    data() {
      return {
        headers: [{
          text: 'Column Name in Raw Discrete Data File',
          align: 'left',
          sortable: true,
          value: 'Id',
        },
        {
          text: 'Column Data Validation Mode',
          align: 'left',
          sortable: false,
          value: DataValidationModeProperty,
        },
        {
          text: 'Column Name Aliases',
          align: 'left',
          sortable: false,
          value: 'NameAliases',
        },
        {
          text: 'Metadata',
          value: 'Metadata',
          align: 'left',
          sortable: false,
        },
        ],
        modalValue: false,
        selectedColumnId: '',
        isLoadingSubmit: false,
        editMode: false,
        pagination: {
          sortBy: '',
          rowsPerPage: -1,
        },
        showValidationModeInfo: false,
      }
    },
    computed: {
      ...eddConfiguration.mapGetters(['findConfigurationEntryInOriginal', 'findConfigurationEntry']),
      namedConfigurationEntry() {
        this.$emit('setPageTitle', {
          pageTitle: `Configure ${this.ConfigurationSettingName} Report Details`,
        })
        return this.findConfigurationEntryInOriginal(this.ConfigurationSettingName)
      },
      currentComponent() {
        if (columnEditModalMapping == null || this.selectedColumnId == null ||
          this.selectedColumnId == '' || columnEditModalMapping[this.selectedColumnId] == null) {
          return ColumnEditModal
        }
        return columnEditModalMapping[this.selectedColumnId]
      },
      dataValidationModeProperty() {
        return DataValidationModeProperty
      },
    },
    methods: {
      ...app.mapActions(['setSnackbar']),
      ...eddConfiguration.mapActions(['submitConfigurationSettings', 'setColumnDataValidationMode',
        'resetConfigurationSettings',
      ]),
      async saveConfiguration() {
        try {
          this.isLoadingSubmit = true
          await this.submitConfigurationSettings()
          this.setSnackbar({
            text: 'Successfully updated configurations',
            color: 'success',
            icon: 'done',
          })
        } catch (err) {
          this.setSnackbar({
            text: `Error occurred saving form ${err}`,
            color: 'error',
            icon: 'error',
          })
        } finally {
          this.isLoadingSubmit = false
        }

      },
      cancelConfiguration() {
        this.goToConfigList()
        this.resetConfigurationSettings()
      },
      setEditMode(val) {
        this.editMode = val
      },
      goToConfigList() {
        this._mixin_routing_navigateTo('configurationSettingsList')
      },
      updateColumnDataValidationMode(newValue, column) {
        this.setColumnDataValidationMode({
          configName: this.ConfigurationSettingName,
          columnId: column.Id,
          dataValidationMode: newValue,
        })
      },
      openEditColumnModal(columnId) {
        this.selectedColumnId = columnId
        this.modalValue = true
      },
      labDataColumnConfigs() {
        let labDataConfig = this.findConfigurationEntry(this.ConfigurationSettingName)
        return (labDataConfig && Object.values(labDataConfig)) || []
      },
      hasAliases(column) {
        return column.NameAliases && column.NameAliases.length && column.NameAliases.length > 1
      },
      getAliasDefaultName(column) {
        let defaultName = column.NameAliases.find(x => x.IsDefault)
        return defaultName && defaultName.Name
      },
      toggleAll() {
        if (this.selected.length) this.selected = []
        else this.selected = this.desserts.slice()
      },
      changeSort(header) {
        if (!header.sortable) {
          return
        }
        const column = header.value
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
    },
    mounted() {
      this.editMode = this.initialEditMode
    },
  }
</script>

<style scoped>
  div>>>.v-input--selection-controls__input {
    padding-top: 20px;
  }
</style>